import { useClient } from 'src/ui/shared/hooks/client.hook';

export const useOrganisationLogoUrl = (bannerFileId: number | undefined) => {
    const client = useClient();
    return bannerFileId
        ? `${client.careerHubBasePath}/services/employers/v1/images/logo`
        : undefined;
};
